<template>
	<div class="row flex-row">
		<div v-for="item in items" :key="item.ID" class="columns column4">
			<div class="promotion">
				<div class="image">
					<picture>
						<source :srcset="item.overviewImageWebp" type="image/webp" />
						<source :srcset="item.overviewImage" />
						<img :src="item.overviewImage" :alt="item.overviewImageAlt" loading="lazy" />
					</picture>
				</div>
				<div class="content">
					<h4>
						<nuxt-link :to="localePath(`/${item.filename}`)">
							{{ item.header }}
						</nuxt-link>
					</h4>
					<div v-parse-links v-html="item.overviewContent" />
					<nuxt-link :to="localePath(`/${item.filename}`)" class="button" target="_self">
						{{ $t('viewThisPackage') }}
					</nuxt-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});
</script>

<style lang="scss" scoped>
.row {
	justify-content: center;
}

.promotion {
	margin: 0 auto 20px;
	position: relative;
	box-shadow: 0 10px 18px rgb(0 0 0 / 20%);

	a {
		text-decoration: none;
		position: relative;
		z-index: 3;
	}

	&::before {
		content: '';
		display: block;
		position: absolute;
		inset: 0;
		z-index: 2;
		background: rgb(0 0 0 / 30%);
		transition: all 0.3s ease-in-out;
	}

	&:hover {
		&::before {
			background: rgb(0 0 0 / 20%);
		}
	}

	.image {
		display: block;
		overflow: hidden;

		img {
			transition: all 0.3s ease-in-out;
			position: relative;
			z-index: 1;
		}
	}

	.content {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 40px;
		color: #fff;
		z-index: 3;

		a,
		h4 {
			color: #fff;
		}
	}
}

@media (max-width: 880px) {
	.promotion {
		.content {
			padding: 25px;
		}
	}
}

@media (max-width: 780px) {
	.promotions {
		.column4 {
			width: 100%;
		}
	}

	.promotion {
		.content {
			padding: 20px;
		}
	}
}
</style>
